import {
    BarChart as RechartsBarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
    Legend,
    Cell,
  } from 'recharts';
import AngledAxisTick from '../AngledAxisTick';
import AnalyticsEmptyState from "../../dashboard/AnalyticsEmptyState";
import { CATEGORICAL } from '../../../helpers/chartPalette'
import { CHART_MARK_STROKE, CHART_MARK_STROKE_WIDTH } from '../../../helpers/chartPalette';

const ScaleDevelopmentBarChart = ({groupedData, colors, primaryColor, totalResponses, scaleEnd, graphColor}) => {
   if (!groupedData || groupedData.length === 0) {
     return <AnalyticsEmptyState />;
   }

   // Transform groupedData into the bar chart format
   const barData = groupedData.map((item) => ({
     name: item.moment, // Use 'moment' as the x-axis label
     value: parseFloat(item.average), // Convert 'average' to a number for the y-axis
   }));

 // Custom Tooltip
 const CustomTooltip = ({ active, payload }) => {
   if (active && payload && payload.length) {
     const { name, value } = payload[0].payload; // Get current data point
     return (
       <div
         style={{
           backgroundColor: 'white',
           border: '1px solid #ccc',
           borderRadius: '5px',
           padding: '10px',
         }}
       >
         <p style={{ margin: 0, fontWeight: 'bold' }}>{name}</p>
         <p style={{ margin: 0 }}>{`Gemiddelde score: ${value}`}</p>
       </div>
     );
   }
   return null;
 };

 return (
   <div
     className="scale-development-chart"
   >
     <ResponsiveContainer width="100%" height="100%">
       <RechartsBarChart
         data={barData}
         margin={{ top: 20, right: 20, left: 20, bottom: 5 }}
       >
         <XAxis
         dataKey="name"
         tick={<AngledAxisTick fill={graphColor || undefined} />}
         interval={0}
         height={70}
         axisLine={false}
         tickLine={false}
         stroke={graphColor || 'black'} />
         <YAxis
         domain={[0, scaleEnd]}
         tick={{ fontSize: 12, fill: graphColor || undefined }}
         axisLine={false}
         tickLine={false}
         stroke={graphColor || 'black'} />
         <Tooltip content={<CustomTooltip />} />
         <Bar dataKey="value" fill={primaryColor || CATEGORICAL[0]} stroke={CHART_MARK_STROKE} strokeWidth={CHART_MARK_STROKE_WIDTH}>
           {barData.map((entry, index) => (
             <Cell key={`cell-${index}`} fill={primaryColor || colors[index % colors.length]} stroke={CHART_MARK_STROKE} strokeWidth={CHART_MARK_STROKE_WIDTH} />
           ))}
         </Bar>
       </RechartsBarChart>
     </ResponsiveContainer>
   </div>
 );
}

export default ScaleDevelopmentBarChart